import { get } from 'stores/_services/dataService';

export { getRuleVersion };

async function getRuleVersion(ruleVersionId) {
    let res;

    let options = {
        filter: {
            include: [
                {
                    relation: 'author',
                    scope: {
                        fields: ['email']
                    }
                }
            ]
        }
    };

    try {
        res = await get(`ruleVersions/${ruleVersionId}/detail`, options);
    } catch (e) {
        console.log(e.message);
    }

    let { data } = res;
    return data;
}
